import React from 'react';
import { observer } from 'mobx-react';

import Styled from 'styled';
import ButtonView from 'four-nets/ui/button-view';

import defaultStyles from './icon-button-view.scss';

export default Styled(defaultStyles)(
    observer(function IconButtonView(props) {
        return <ButtonView {...props} unbounded={true} />;
    })
);
